import axios from "axios";
import api from "../config/api-config";

export const getAllHotels = (payload) =>
    axios.post(`${api.host}/hotel/theme`, payload, {
});
